// extracted by mini-css-extract-plugin
export var footer = "index-module--footer--1UNE0";
export var footerContent = "index-module--footerContent--a5yu2";
export var logoContainer = "index-module--logoContainer--2cCAq";
export var socialLinksContainer = "index-module--socialLinksContainer--3dQcA";